<template>
    <div
        id="todo-app"
        class="emc_app border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
    >
        <vue-headful :title="$t('emc_title')" />
        <vs-sidebar
            class="items-no-padding"
            parent="#todo-app"
            :click-not-close="clickNotClose"
            :hidden-background="clickNotClose"
            v-model="isSidebarActive"
        >
            <!-- ФУНКЦИОНАЛ СОЗДАНИЯ -->
            <!-- <component  v-bind:is=""></component> -->
            <TeacherAddButton v-if="$store.state.user.roles.is_teacher && updatedd"
            @closeView="closeEmcViewSidebar()"  @closed="closedAddButton" :updatedData="updatedData" />

            <!-- ФИЛЬТРЫ УМК -->
            <ListFilters
                ref="ListFilters"
                :rules="rules"
                @closesidebar="toggleTodoSidebar"
                :itemHandler="infiniteHandle"
                :sidebarToggle="toggleTodoSidebar"
                :activeTab="activeTab"
            />
        </vs-sidebar>
        <div
            :class="{ 'sidebar-spacer': clickNotClose }"
            class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
        >
            <!-- HEADER СПИСКА УМК -->
            <div
                :class="[
                    'emc__actions flex items-center flex-wrap justify-between',
                    rules.is_teacher &&
                        'border border-r-0 border-l-0 border-solid d-theme-border-grey-light',
                ]"
            >
                <feather-icon
                    class="cursor-pointer emc_mobile_sidebar md:inline-flex lg:hidden ml-4 mr-4"
                    icon="MenuIcon"
                    @click.stop="toggleTodoSidebar(true)"
                />
                <vs-tabs v-if="rules.is_teacher" v-model="activeTab">
                    <!-- Табы Все УМК/Мои УМК -->
                    <vs-tab
                        @click="tabHandler()"
                        :label="$t('my_emc')"
                    ></vs-tab>
                    <vs-tab
                        @click="tabHandler()"
                        :label="$t('all_emc')"
                    ></vs-tab>
                </vs-tabs>
            </div>

            <!-- СПИСОК УМК -->
            <component
                :is="'VuePerfectScrollbar'"
                :class="[
                    'infinite_scroll_wrapper',
                    rules.is_teacher && 'teacher_scroll',
                ]"
                ref="emcListScroll"
                :settings="settings"
                :key="$vs.rtl"
                @ps-y-reach-end="infiniteHandle"
            >
                <!-- Контент табов Все УМК/Мои УМК -->
                <vs-tabs ref="tabs" class="emc_list_tabs" :value="activeTab">
                    <vs-tab>
                        <ul v-if="emcList.length">
                            <li
                                class="todo_todo-item cursor-pointer"
                                v-for="(item, index) in emcList"
                                @click="updateOpenEmc(item.uid)"
                                :key="`d_${index}`"
                                :style="[
                                    { transitionDelay: index * 0.1 + 's' },
                                ]"
                            >
                                <ListItem :item="item" />
                            </li>
                        </ul>
                        <div class="mt-4 ml-5 mr-5" v-if="emcEmptyMessage">
                            <vs-alert active="true">
                                {{ $t("no_data_text") }}
                            </vs-alert>
                        </div>
                    </vs-tab>
                    <vs-tab>
                        <ul v-if="emcTeacherList.length">
                            <li
                                class="todo_todo-item cursor-pointer"
                                v-for="(item, index) in emcTeacherList"
                                @click="updateOpenEmc(item.uid)"
                                :key="`d_${index}`"
                                :style="[
                                    { transitionDelay: index * 0.1 + 's' },
                                ]"
                            >
                                <ListItem :item="item" />
                            </li>
                        </ul>
                        <div class="mt-4 ml-5 mr-5" v-if="emcEmptyMessage2">
                            <vs-alert active="true">
                                {{ $t("no_data_text") }}
                            </vs-alert>
                        </div>
                    </vs-tab>
                </vs-tabs>

                <!-- В этот див выводил лоадер -->
                <div
                    id="infinite_loader"
                    class="vs-con-loading__container"
                ></div>
            </component>
        </div>

        <!-- ПРОСМОТР УМК -->
        <EmcView
            :openEmcId="openEmcId"
            @closesidebar="closeEmcViewSidebar"
            :isEmcSidebarActive="isEmcSidebarActive"
            @editEmc="editEmc"
            @deleteEmc="deleteEmc"
        />
    </div>
</template>

<script>
import moduleEmc from "@/store/modules/emc.js";
import ListItem from "./ListItem.vue";
import ListFilters from "./ListFilters.vue";
import EmcView from "./EmcView.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import TeacherAddButton from "@/pages/Home/Emc/EmcAddModal";
import {eventBus} from '../../../main'

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    data() {
        return {
            totalPage: 0,
            totalPage2: 0,
            emcEmptyMessage: false,
            emcEmptyMessage2: false,
            loading: false,
            openEmcId: "",
            clickNotClose: true,
            displayPrompt: false,
            taskIdToEdit: 0,
            searchQuery: "",
            isSidebarActive: true,
            updatedData: null,
            updatedd: true,
            isEmcSidebarActive: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
        };
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
    },
    computed: {
        ...mapGetters({
            emcList: "emc/getEmc",
            emcTeacherList: "emc/getEmcTeacher",
            scrollbarTag: "scrollbarTag"
        }),
        page: {
            get() {
                return this.$store.state.emc.page
            },
            set(value) {
                this.$store.commit("emc/SET_PAGE", value)
            }
        },
        page2: {
            get() {
                return this.$store.state.emc.page2
            },
            set(value) {
                this.$store.commit("emc/SET_PAGE2", value)
            }
        },
        infiniteStatus: {
            get() {
                return this.$store.state.emc.infiniteStatus
            },
            set(value) {
                this.$store.commit("emc/SET_INF_STATUS", value)
            }
        },
        infiniteStatus2: {
            get() {
                return this.$store.state.emc.infiniteStatus2
            },
            set(value) {
                this.$store.commit("emc/SET_INF_STATUS2", value)
            }
        },
        activeTab: {
            // Активный таб
            get() {
                return this.$store.state.emc.activeTab;
            },
            set(value) {
                this.$store.commit("emc/SET_ACTIVE_TAB", value);
            }
        },

        rules() {
            return this.$store.state.user.roles;
        },
        windowWidth() {
            return this.$store.state.windowWidth;
        }
    },
    mounted(){
        this.start()
    },
    methods: {
        ...mapActions({
            fetchEmc: "emc/fetchEmc",
            fetchEmcTeacher: "emc/fetchEmcTeacher",
        }),
        ...mapMutations({
            deleteEmcDinData: "emc/deleteEmcDinData"
        }),
        closedAddButton(){

            this.updatedData = null;
            this.updatedd = false;
            setTimeout(() => {
                this.updatedd = true
            }, 10);

        },
        start(){
            eventBus.$emit('startEmc', true)
        },


        tabHandler() {
            // const query = this.$route.query
            // const oldFIlters = this.$store.state.emc.oldFilters

            // Прокручиваем список к верху
            this.$refs["emcListScroll"].$el.scrollTop = 0;

            // Подставляем query в роут в зависимости от текущего таба
            // if(JSON.stringify(oldFIlters) !== JSON.stringify(query)) {
            //    this.$router.push({query: oldFIlters})
            //    this.$refs['ListFilters'].getActionFilters()
            // }

            // Заменяем активные поля в фильтре в зависимости от текущего таба
            // this.$store.commit('emc/SET_OLD_FILTERS', query)

            // Обновляем список умк в зависимости от открытого таба
            if (this.activeTab === 1) {
                this.$store.commit("emc/CLEAR_EMC_TEACHER");
                this.infiniteStatus2 = true;
                this.page2 = 0;
                this.emcTeacherHandler();
            } else {
                this.$store.commit("emc/CLEAR_EMC");
                this.infiniteStatus = true;
                this.page = 0;
                this.emcHandler();
            }

            // Сохраняем активный таб
            localStorage.setItem("emc_active_tab", this.activeTab);
        },
        async deleteEmc(emc){
            try{
                this.$vs.loading()
                const res = await this.$http.delete(`emc/delete/${ emc.uid }`)
                if(res.status === 204){
                    this.deleteEmcDinData(emc.uid);
                    this.$vs.notify({
                        title: this.$t('succesful'),
                        color: "success"
                    })

                    this.closeEmcViewSidebar()
                }
            }
            catch(e){
                this.$vs.notify({
                    title: this.$t('error'),
                    color: "danger"
                })
            }
            finally{
                this.$vs.loading.close()
            }
        },
        async editEmc(emc){
            this.updatedData = emc;
            eventBus.$emit('editEmc', true)
        },
        closeEmcViewSidebar() {
            // Закрываем окно просмотра умк
            this.isEmcSidebarActive = false;
        },
        updateOpenEmc(emc_uid) {
            // Открываем окно просмотра умк
            this.openEmcId = emc_uid;
            this.isEmcSidebarActive = true;
        },
        infiniteHandle({ update = false }) {
            // Событие прокрутки до низа списка

            // Если update == true, обновляем записи умк
            if (update) {
                // Проверяем активный таб чтобы запрашивать умк для нужного таба
                if (this.activeTab === 0) {
                    this.infiniteStatus = true;
                    this.page = 0;
                } else {
                    this.infiniteStatus2 = true;
                    this.page2 = 0;
                }

                // Закрываем окно умк если открыто, при обновлении фильтра
                this.isEmcSidebarActive = false;
            }

            if (this.activeTab === 0) this.emcHandler();
            else this.emcTeacherHandler();
        },
        async emcHandler() {
            // Если нет загрузки и статус инфинити скролла положительный, запрашиваем умк для нужной страницы
            if (!this.loading && this.infiniteStatus) {
                this.loading = true;
                this.emcEmptyMessage = false;
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: "#infinite_loader",
                        scale: 0.6,
                    });
                });

                try {
                    this.page = this.page + 1;
                    const res = await this.fetchEmc({
                        page: this.page,
                        route: this.$route,
                    });

                    // Если данных нет показываем сообщение
                    if (!res || (res.current_page === 1 && !res.results.length))
                        this.emcEmptyMessage = true;

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if (!res || res.total_pages <= this.page)
                        this.infiniteStatus = false;
                } catch ({ detail }) {
                    this.$vs.notify({
                        text: detail,
                        color: "danger",
                    });
                } finally {
                    this.loading = false;
                    this.$vs.loading.close(
                        "#infinite_loader > .con-vs-loading"
                    );
                }
            }
        },
        async emcTeacherHandler() {
            // Если нет загрузки и статус инфинити скролла положительный, запрашиваем умк других учителей для нужной страницы
            if (!this.loading && this.infiniteStatus2) {
                this.loading = true;
                this.emcEmptyMessage2 = false;

                this.$nextTick(() => {
                    this.$vs.loading({
                        container: "#infinite_loader",
                        scale: 0.6,
                    });
                });

                try {
                    this.page2 = this.page2 + 1;
                    const res = await this.fetchEmcTeacher({
                        page: this.page2,
                        route: this.$route,
                    });

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if (!res || res.total_pages <= this.page2)
                        this.infiniteStatus2 = false;

                    // Если данных нет показываем сообщение
                    if (res.current_page === 1 && !res.results.length)
                        this.emcEmptyMessage2 = true;
                } catch ({ detail }) {
                    this.$vs.notify({
                        text: detail,
                        color: "danger",
                    });
                } finally {
                    this.loading = false;
                    this.$vs.loading.close(
                        "#infinite_loader > .con-vs-loading"
                    );
                }
            }
        },
        hidePrompt() {
            this.displayPrompt = false;
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
        toggleTodoSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
            this.isSidebarActive = value;
        }
    },
    components: {
        ListItem,
        ListFilters,
        EmcView,
        VuePerfectScrollbar,
        TeacherAddButton
    },
    created() {
        // Регистрируем стор EMC
        if(!this.$store.hasModule('emc'))
            this.$store.registerModule("emc", moduleEmc);
        this.start();

        this.setSidebarWidth();
    },
    beforeDestroy() {
        // Если покидаем текущий компонент, удаляем стор EMC
        this.$store.unregisterModule("emc");
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
@media only screen and (min-width: 993px) {
    .emc_app{
        .vs-sidebar-position-right{
            max-width: calc(100% - 260px)!important;
        }
    }
}
.emc__actions {
    .con-vs-tabs {
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs {
        display: none;
    }
}
.emc_list_tabs {
    .con-ul-tabs {
        display: none;
    }
    .vs-tabs--content {
        padding: 0px;
    }
}
.filters_scroll_area {
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher {
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher) {
        height: 100%;
    }
}
.infinite_scroll_wrapper {
    margin: auto;
    position: relative;
    width: 100%;
    &:not(.teacher_scroll) {
        height: 100%;
    }
    &.teacher_scroll {
        height: calc(100% - 42px);
    }
    .infinite_alert {
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader {
    padding: 20px 0;
    .con-vs-loading {
        background: transparent;
    }
}
.full-vs-sidebar {
    .mail-sidebar-content {
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
    }
}
</style>
